
export type ComputableLayoutOffsetOperation = 
  | 'multiply'
  | 'divide'
  | 'add'
  | 'subtract';